import { Alert, AlertTitle, useTheme } from '@mui/material';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import React from 'react';

import { PremiumJobApplicationSubStatus } from '@modules/jobApplications/statuses';

interface InterviewScheduledBannerProps {
    interviewScheduledAt?: string | null;
    subStatus?: string | null;
}

const HIDDEN_SUB_STATUSES = new Set<string>([
    PremiumJobApplicationSubStatus.Canceled,
    PremiumJobApplicationSubStatus.Conducted,
    // ── Client-managed (after DC.Sent, clients handle via status/subStatus) ──
    // PremiumJobApplicationSubStatus.InterviewRejected,
]);

const InterviewScheduledBanner: React.FC<InterviewScheduledBannerProps> = ({ interviewScheduledAt, subStatus }) => {
    const theme = useTheme();

    if (!interviewScheduledAt) return null;
    if (subStatus && HIDDEN_SUB_STATUSES.has(subStatus)) return null;

    const scheduledDate = new Date(interviewScheduledAt);
    if (Number.isNaN(scheduledDate.getTime())) return null;

    const isPast = scheduledDate.getTime() < Date.now();
    const formatted = format(scheduledDate, "dd MMMM yyyy 'à' HH:mm", { locale: fr });

    return (
        <Alert
            severity="info"
            icon={<i className="fi fi-br-calendar" style={{ fontSize: 14, display: 'flex', alignItems: 'center' }} />}
            sx={{
                borderRadius: 2,
                backgroundColor: theme.palette.info.main + '1A',
                color: theme.palette.text.primary,
                border: `1px solid ${theme.palette.info.main}55`,
                alignItems: 'center',
            }}>
            <AlertTitle sx={{ m: 0, fontWeight: 700 }}>
                {isPast ? 'Entretien planifié' : 'Entretien à venir'}
            </AlertTitle>
            {formatted}
        </Alert>
    );
};

export default InterviewScheduledBanner;
